import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Table from '../common/Table';
import RTButton from '../common/RTButton';
import '../common/rtCommon.css';
import './BedPricing.css';
import RTPageLayout from '../common/RTPageLayout';

const BedPricing = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Hardcoded pricing data
  const pricingData = [
    {
      id: 1,
      sharing: 'Single Sharing',
      roomType: 'AC',
      amount: 15000,
      currency: '₹'
    },
    {
      id: 2,
      sharing: 'Single Sharing',
      roomType: 'Non-AC',
      amount: 15000,
      currency: '₹'
    },
    {
      id: 3,
      sharing: 'Double Sharing',
      roomType: 'AC',
      amount: 13000,
      currency: '₹'
    },
    {
      id: 4,
      sharing: 'Double Sharing',
      roomType: 'Non-AC',
      amount: 13000,
      currency: '₹'
    },
    {
      id: 5,
      sharing: 'Triple Sharing',
      roomType: 'AC',
      amount: 11000,
      currency: '₹'
    },
    {
      id: 6,
      sharing: 'Triple Sharing',
      roomType: 'Non-AC',
      amount: 11000,
      currency: '₹'
    },
    {
      id: 7,
      sharing: 'Four Sharing',
      roomType: 'AC',
      amount: 10000,
      currency: '₹'
    },
    {
      id: 8,
      sharing: 'Four Sharing',
      roomType: 'Non-AC',
      amount: 10000,
      currency: '₹'
    }
  ];

  // Table columns configuration
  const columns = [
    {
      Header: 'Number of Sharing',
      accessor: 'sharing'
    },
    {
      Header: 'Room Type',
      accessor: 'roomType'
    },
    {
      Header: 'Rent',
      accessor: 'amount',
      Cell: ({ value, row }) => `${row.currency}${value.toLocaleString()} per month`
    }
  ];

  const handleBack = () => {
    navigate('/bed-allocation');
  };

  return (
    <RTPageLayout
      activePath={location.pathname}
      title="Bed Pricing"
      mainSection={true}
    >
      <div className="bed-pricing-container">
        <div className="bed-pricing-table-section">
          <Table
            columns={columns}
            data={pricingData}
            showSearch={false}
            exportable={true}
            showPagination={true}
            pageSize={10}
            showTotalCount={false}
            totalCountText="Total pricing entries"
            noDataText="No pricing data available."
          />
        </div>

        <div className="bed-pricing-footer">
          <p className="bed-pricing-description">
            View and manage pricing for different bed sharing options and room types.
            Prices are listed as monthly rent amounts.
          </p>
          <p className="bed-pricing-disclaimer">
            <strong>** Rent may vary depending on various other factors and decision of management is final.</strong>
          </p>
        </div>
      </div>
    </RTPageLayout>
  );
};

export default BedPricing;
